import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ThresholdModule } from '@blade-sxp/task-management/store/threshold';
const NOTIFIDATA = {
    value: 10,
    minor: '',
    critical: '',
    major: '',
    minorTime: '',
    criticalTime: '',
    majorTime: '',
    enabledAlarmLevels: [],
    enabledTimeAlarmLevels: [],
};
let AlertNotification = class AlertNotification extends Vue {
    notifData;
    typeChoose;
    type;
    disabled;
    isEdit = true;
    formData = JSON.parse(JSON.stringify(NOTIFIDATA));
    checkMinor = false;
    checkCritical = false;
    checkMajor = false;
    checkMinorTime = false;
    checkCriticalTime = false;
    checkMajorTime = false;
    rulesFrom = true;
    choose;
    onChangeNotifData(val) {
        if (this.notifData && this.choose !== 'add') {
            if (!this.notifData.alarmConfig)
                return;
            if (!this.notifData.alarmConfig.notifyConfig)
                return;
            const frequency = val?.alarmConfig?.notifyConfig?.frequency?.value;
            if (frequency) {
                this.formData.value = val.alarmConfig.notifyConfig.frequency.value;
            }
            if (val.alarmConfig.notifyConfig.enabledAlarmLevels) {
                this.formData.enabledAlarmLevels = val.alarmConfig.notifyConfig.enabledAlarmLevels;
                if (this.formData.enabledAlarmLevels.includes('MAJOR') &&
                    this.formData.enabledAlarmLevels.includes('CRITICAL') &&
                    this.formData.enabledAlarmLevels.includes('MINOR')) {
                    this.checkCritical = true;
                    this.checkMajor = true;
                }
                if (this.formData.enabledAlarmLevels.includes('MAJOR') &&
                    this.formData.enabledAlarmLevels.includes('CRITICAL') &&
                    !this.formData.enabledAlarmLevels.includes('MINOR')) {
                    this.checkCritical = true;
                }
            }
            if (val.alarmConfig.notifyConfig.enabledTimeAlarmLevels) {
                this.formData.enabledTimeAlarmLevels = val.alarmConfig.notifyConfig.enabledTimeAlarmLevels;
            }
            const levelConfig = val.alarmConfig.thresholdConfigs[0].levelConfig;
            if (levelConfig.minor && levelConfig.critical && levelConfig.major) {
                this.formData.minor = val.alarmConfig.thresholdConfigs[0].levelConfig.minor;
                this.formData.critical = val.alarmConfig.thresholdConfigs[0].levelConfig.critical;
                this.formData.major = val.alarmConfig.thresholdConfigs[0].levelConfig.major;
            }
            if (val.alarmConfig.thresholdConfigs.length > 1) {
                if (val.alarmConfig.thresholdConfigs[1].levelConfig.minor) {
                    this.formData.minorTime = val.alarmConfig.thresholdConfigs[1].levelConfig.minor;
                }
                if (val.alarmConfig.thresholdConfigs[1].levelConfig.critical) {
                    this.formData.criticalTime = val.alarmConfig.thresholdConfigs[1].levelConfig.critical;
                }
                if (val.alarmConfig.thresholdConfigs[1].levelConfig.major) {
                    this.formData.majorTime = val.alarmConfig.thresholdConfigs[1].levelConfig.major;
                }
            }
        }
        ThresholdModule.updataThreshold(this.formData);
    }
    mounted() {
        this.choose = this.typeChoose;
        this.onChangeNotifData(this.notifData);
    }
    changeEnabledAlarm(val) {
        console.log(this.formData.enabledAlarmLevels, 'this.formData.enabledAlarmLevels12');
        this.checkMinor = false;
        this.checkCritical = false;
        this.checkMajor = false;
        for (let value of val) {
            if (value === 'MAJOR') {
                this.formData.enabledAlarmLevels = ['MAJOR'];
                this.formData.enabledAlarmLevels.push('CRITICAL');
                this.checkCritical = true;
            }
            if (value === 'MINOR') {
                this.formData.enabledAlarmLevels = ['MINOR'];
                this.checkCritical = true;
                this.checkMajor = true;
                this.formData.enabledAlarmLevels.push('CRITICAL');
                this.formData.enabledAlarmLevels.push('MAJOR');
            }
        }
    }
    changeEnabledAlarmTime(val) {
        this.checkMinorTime = false;
        this.checkCriticalTime = false;
        this.checkMajorTime = false;
        for (let value of val) {
            if (value === 'MAJOR') {
                this.formData.enabledTimeAlarmLevels = ['MAJOR'];
                this.formData.enabledTimeAlarmLevels.push('CRITICAL');
                this.checkCriticalTime = true;
            }
            if (value === 'MINOR') {
                this.formData.enabledTimeAlarmLevels = ['MINOR'];
                this.checkCriticalTime = true;
                this.checkMajorTime = true;
                this.formData.enabledTimeAlarmLevels.push('CRITICAL');
                this.formData.enabledTimeAlarmLevels.push('MAJOR');
            }
        }
    }
    positiveInt(value) {
        const reg = /^[1-9][0-9]{0,3}$/;
        return reg.test(value);
    }
    // 取消编辑
    cancelEdit() {
        this.isEdit = true;
        this.formData = JSON.parse(JSON.stringify(ThresholdModule.thresholdValue));
    }
    // 保存编辑
    saveEdit(formName) {
        this.checkFormData();
        if (!this.rulesFrom) {
            this.choose = 'add';
            this.isEdit = true;
            ThresholdModule.updataThreshold(this.formData);
            this.$emit('threshold-set', this.formData);
        }
        else {
            this.isEdit = false;
        }
        // 提交数据
    }
    checkFormData() {
        if (!this.formData.minor || !this.formData.major || !this.formData.critical) {
            this.$message.error(`${this.$t('peopleThreshold')}`);
            this.rulesFrom = true;
            return;
        }
        else if (!this.formData.value) {
            this.$message.error(`${this.$t('alarmRequired')}`);
            this.rulesFrom = true;
            return;
        }
        else if (Number(this.formData.minor) >= Number(this.formData.major) ||
            Number(this.formData.minor) >= Number(this.formData.critical)) {
            this.$message.error(`${this.$t('minorTip')}`);
            this.rulesFrom = true;
            return;
        }
        else if (Number(this.formData.major) <= Number(this.formData.minor) ||
            Number(this.formData.major) >= Number(this.formData.critical)) {
            this.$message.error(`${this.$t('majorTip')}`);
            this.rulesFrom = true;
            return;
        }
        else if (Number(this.formData.critical) < Number(this.formData.major) ||
            Number(this.formData.critical) < Number(this.formData.minor)) {
            this.$message.error(`${this.$t('criticalTip')}`);
            this.rulesFrom = true;
        }
        else if (!this.positiveInt(this.formData.minor) ||
            !this.positiveInt(this.formData.major) ||
            !this.positiveInt(this.formData.critical)) {
            this.$message.error(`${this.$t('positiveInteger')}`);
            this.rulesFrom = true;
            return;
        }
        else {
            this.rulesFrom = false;
        }
        for (let value of this.formData.enabledTimeAlarmLevels) {
            if (value === 'MINOR') {
                if (!this.positiveInt(this.formData.minorTime)) {
                    this.$message.error(`${this.$t('positiveInteger')}`);
                    this.rulesFrom = true;
                    return;
                }
            }
            if (value === 'CRITICAL') {
                if (!this.positiveInt(this.formData.criticalTime)) {
                    this.$message.error(`${this.$t('positiveInteger')}`);
                    this.rulesFrom = true;
                    return;
                }
            }
            if (value === 'MAJOR') {
                if (!this.positiveInt(this.formData.majorTime)) {
                    this.$message.error(`${this.$t('positiveInteger')}`);
                    this.rulesFrom = true;
                    return;
                }
            }
        }
        if (this.formData.minorTime) {
            if (!this.positiveInt(this.formData.criticalTime)) {
                this.$message.error(`${this.$t('positiveInteger')}`);
                this.rulesFrom = true;
                return;
            }
            if (Number(this.formData.minorTime) >= Number(this.formData.majorTime) ||
                Number(this.formData.minorTime) >= Number(this.formData.criticalTime)) {
                this.$message.error(`${this.$t('criticalTip')}`);
                this.rulesFrom = true;
                return;
            }
        }
        if (this.formData.majorTime) {
            if (!this.positiveInt(this.formData.majorTime)) {
                this.$message.error(`${this.$t('positiveInteger')}`);
                this.rulesFrom = true;
                return;
            }
            if (Number(this.formData.majorTime) <= Number(this.formData.minorTime) ||
                Number(this.formData.majorTime) >= Number(this.formData.criticalTime)) {
                this.$message.error(`${this.$t('criticalTip')}`);
                this.rulesFrom = true;
                return;
            }
        }
        if (this.formData.criticalTime) {
            if (!this.positiveInt(this.formData.criticalTime)) {
                this.$message.error(`${this.$t('positiveInteger')}`);
                this.rulesFrom = true;
                return;
            }
            if (Number(this.formData.criticalTime) <= Number(this.formData.majorTime) ||
                Number(this.formData.criticalTime) <= Number(this.formData.minorTime)) {
                this.$message.error(`${this.$t('criticalTip')}`);
                this.rulesFrom = true;
                return;
            }
        }
        this.rulesFrom = false;
        if (!this.positiveInt(Number(this.formData.value))) {
            this.$message.error(`${this.$t('positiveInteger')}`);
            this.rulesFrom = true;
        }
    }
    // 编辑
    editNotification() {
        this.isEdit = false;
    }
};
__decorate([
    Prop()
], AlertNotification.prototype, "notifData", void 0);
__decorate([
    Prop({ default: '' })
], AlertNotification.prototype, "typeChoose", void 0);
__decorate([
    Prop({ default: 'population-statistics' })
], AlertNotification.prototype, "type", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], AlertNotification.prototype, "disabled", void 0);
__decorate([
    Watch('notifData', { deep: true, immediate: true })
], AlertNotification.prototype, "onChangeNotifData", null);
AlertNotification = __decorate([
    Component({
        name: 'AlertNotification',
        components: {},
        i18n: {
            messages: {
                en: {
                    roiArea: 'ROI Area',
                    positiveInteger: 'Please enter a positive integer from 1-9999',
                    criticalTip: 'Severe must be greater than moderate and mild',
                    majorTip: 'Moderate must be less than severe and greater than mild',
                    minorTip: 'Mild must be less than moderate and severe',
                    min: 'Min',
                    visitor: 'visitors',
                    critical: 'Critical',
                    major: 'Major',
                    minor: 'Minor',
                    alertInterval: 'Alert Interval',
                    alertNotification: 'Alert Notification',
                    notification: 'Level',
                    threshold: 'Threshold(visitors)',
                    thresholdTime: 'Threshold',
                    edit: 'Edit',
                    cancel: 'Cancel',
                    save: 'Save',
                    peopleThreshold: 'The number threshold is required',
                    alarmRequired: 'Alarm interval is required',
                    queueLength: 'Queue Length',
                    waitingTime: 'Waiting Time(Optional)',
                },
                zh: {
                    roiArea: 'ROI 区域',
                    positiveInteger: '请输入 1-9999 的正整数',
                    peopleThreshold: '人数阈值必填',
                    criticalTip: '重度必须大于中度和轻度',
                    majorTip: '中度必须小于重度并且大于轻度',
                    minorTip: '轻度必须小于中度和重度',
                    min: '分钟',
                    visitor: '',
                    critical: '重度',
                    major: '中度',
                    minor: '轻度',
                    alertInterval: '告警间隔',
                    alertNotification: '阈值设置',
                    notification: '等级',
                    threshold: '人数阈值',
                    edit: '编辑',
                    cancel: '取消',
                    save: '保存',
                    waitingTime: '等待时间(可选)',
                    alarmRequired: '告警间隔必填',
                    queueLength: '队列长度',
                },
            },
        },
    })
], AlertNotification);
export default AlertNotification;
